import React, { useContext } from 'react';
import { WatchFullInfoContext, IWatchFullInfoContext } from '../../../watchFullInfoState/watchFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import { Badge } from 'components/Badge';
import Text from 'components/Text/Text';

export const Status: React.FC = () => {
	const { watchFullInfo } = useContext<IWatchFullInfoContext>(WatchFullInfoContext);

	return (
		<div>
			<FullInfoField
				label="stateLabel"
				childrenContent={
					watchFullInfo?.isActive ? (
						<Badge color="green">
							<Text
								translationNameSpace="form"
								translationKey="activeLabel"
								asFragment={true}
								data-test="active"
							/>
						</Badge>
					) : (
						<Badge color="red">
							<Text
								translationNameSpace="form"
								translationKey="notActiveLabel"
								asFragment={true}
								data-test="notActive"
							/>
						</Badge>
					)
				}
			/>
		</div>
	);
};
